import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "View"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M23.2047 11.745C21.4017 7.08128 16.9963 3.9379 11.9997 3.75C7.00311 3.9379 2.59766 7.08128 0.794681 11.745C0.735106 11.9098 0.735106 12.0902 0.794681 12.255C2.59766 16.9187 7.00311 20.0621 11.9997 20.25C16.9963 20.0621 21.4017 16.9187 23.2047 12.255C23.2643 12.0902 23.2643 11.9098 23.2047 11.745ZM7.5 12C7.5 9.51472 9.51472 7.5 12 7.5C14.4853 7.5 16.5 9.51472 16.5 12C16.5 14.4853 14.4853 16.5 12 16.5C9.51472 16.5 7.5 14.4853 7.5 12ZM9 12C9 13.6569 10.3431 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12ZM2.30224 12C3.82474 15.8025 8.02474 18.75 11.9997 18.75C15.9747 18.75 20.1747 15.8025 21.6972 12C20.1747 8.1975 15.9747 5.25 11.9997 5.25C8.02474 5.25 3.82474 8.1975 2.30224 12Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/View.vue"]]);
